import type { Method } from 'lib/axios';
import type { AiPhotoGenerationImageStyleType } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';

import { APICallV4 } from '../APICall';

interface IResponseData {
    image: string;
}

export class ImproveImageApiCall extends APICallV4<IResponseData> {
    _method = 'generate/image';
    _type: Method = 'post';
    _retriesCount = 0;
}

export const generateImageApiCall = ({
    prompt,
    style,
    signal,
}: {
    prompt: string;
    style?: AiPhotoGenerationImageStyleType;
    signal?: AbortSignal;
}) => new ImproveImageApiCall().makeRequest({ prompt, style }, { signal });
